import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Common/Button";
import "./style.scss";
import {useSelector} from "react-redux";
import {selectCv} from "../../../../slices/profile";
import {Card, Col, Image, Placeholder, Row} from "react-bootstrap";
import {storage} from "../../../../firebase";
import {StudentChartSoftSkillsType} from "../../../../db/models/student/cv";
import {SoftSkillTagType} from "../../../../db/models/softSkill";
import {softSkillsDataset} from "../../../../db/models/const";

interface Props {
    handleGoNext: Function;
}

const spentTime = (a: number, b: number): number => (b - a) / 1000 // return seconds
const USER_WAIT_TIME = 3500 //milliseconds

const StudentOnboardingEmoji = ({handleGoNext}) => {
    const [softSkill, setSoftSkill] = useState<any>();
    const [url, setUrl] = useState<any>();
    const {t, i18n} = useTranslation();
    // const user = useSelector(selectUser);
    const cv = useSelector(selectCv);
    const cvRef = useRef(cv);
    const [loading, setLoading] = useState<boolean>(true);
    const [initTime] = useState(Date.now());

    useEffect(() => {
        cvRef.current = cv;
    }, [cv])

    useEffect(() => {
        const timer = setTimeout(() => {
            handleShowEmoji();
        }, USER_WAIT_TIME);
        return () => clearTimeout(timer);
    }, []);

    const handleShowEmoji = () => {
        if(!cvRef.current) {
            handleGoNext();
            return;
        }
        const softSkills: StudentChartSoftSkillsType = cvRef.current?.softSkills || {};
        const maxSoftValue = Math.max(...Object.values(softSkills));
        const tag: SoftSkillTagType = Object.entries(softSkills).find((e) => e[1] === maxSoftValue)?.[0] as SoftSkillTagType;

        if (!tag) {
            handleGoNext();
            return;
        }

        const softSkill = softSkillsDataset[tag];
        setSoftSkill(softSkill);
        storage.ref("emoji/" + softSkill.storageFileName).getDownloadURL().then(url => setUrl(url));
        setLoading(false)
    };

    return (
        <div className="studentOnboardingEmoji dark-bg">
            <div className="container">
                {loading &&
                    // normal spinner is used because it has usually shown less 1 seconds ;)
                    <Card>
                        <Card.Body>
                            <div className="my-4 text-center">
                                <Placeholder as={Card.Title} animation="glow">
                                    <Placeholder xs={6} md={4} size={"lg"} className={"p-4"}/>
                                </Placeholder>
                                <Placeholder as={Card.Text} animation="glow">
                                    <Placeholder xs={6}/>{' '}<Placeholder xs={5}/>
                                    <Placeholder xs={4}/>{' '}<Placeholder xs={7}/>
                                    <Placeholder xs={7}/> <Placeholder xs={4}/>{' '}
                                    <Placeholder xs={7}/> <Placeholder xs={4}/> <Placeholder xs={4}/>{' '}
                                </Placeholder>
                                {/*<Image rounded className="mb-4" src={"..."} height={200} fluid/>*/}
                                <div className={"mx-auto my-3 rounded"}
                                     style={{maxWidth: "200px", height: "180px", backgroundColor: "rgba(134,142,150,0.74)"}}>
                                </div>
                                <Placeholder.Button className={"mt-4 circle_placeholder p-4 my-2"}
                                                    variant="primary" xs={11} size={"lg"} animation="glow"/>
                            </div>
                        </Card.Body>
                    </Card>
                }
                {!loading &&
                    <div className="card p-5 mt-5">
                        <h2 className="studentOnboardingEmoji__title mb-4">{t("student_onboarding_emojiResult_title")}</h2>
                        {softSkill && (
                            <>
                                <p className="fs-4 mb-4 text-center">
                                    <span className="fw-bold">{t("student_onboarding_emojiResult_preDesc")}</span>
                                    <span className={"text-justify"}>{t(softSkill?.description)}</span>
                                </p>
                                <Row className="justify-content-center">
                                    <Col xs={6} sm={4}>
                                        <Image rounded className="mb-4" src={url} height={200} fluid/>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Button onClick={handleGoNext} filled backgroundColor="#3392E8" borderColor="#3392E8">
                            {t("student_onboarding_emoji_btn")}
                        </Button>
                    </div>}
            </div>
        </div>
    );
};

export default StudentOnboardingEmoji;
